export * from './rectangle.model';
export { createRectangle } from './rectangle.creator';
